module.exports = __webpack_public_path__ + "static/media/bear300_2c_2.49fb8979.svg";